<nav class="navbar navbar-expand-lg navbar-light px-3 py-0" style=" background: white;">
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>

  <a class="navbar-brand" href="#">
    <img src="assets/logo.png" width="150" height="56">
  </a>

  <!-- Mobile -->
  <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="token && profile"
    style="list-style-type: none;">
    <a class="nav-link mt-1" id="notiDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
      aria-expanded="false">
      <img src="assets/notification.png" width="23" height="23" alt="">
      <span *ngIf="notibadge > 0" [matBadge]="notibadge >= 99 ? '99+' : notibadge" matBadgeOverlap="true"
        matBadgeColor="warn" style="display: inline-block;"></span>
    </a>

    <div class="dropdown-menu dropdown-menu-right noti-width-mobile" aria-labelledby="notiDropdown">
      <div class="list-group">
        <a *ngFor="let noti of notiArr; let i = index"
          class="list-group-item list-group-item-action flex-column align-items-start" [ngClass]="i < 7 ? '' : 'd-none'"
          (click)="updateStatusNoti(noti)">
          <div *ngIf="i < 7">
            <div class="d-flex w-100 justify-content-between">
              <h6 [ngClass]="noti.NOTI_STATUS === 0 ? 'unread' : null" class="mb-1">{{ noti.NOTI_TITLE }}</h6>
              <small class="text-muted" style="width: 33%;">
                <span *ngIf="noti.NOTI_STATUS === 0" class="unread">
                  •</span> {{ noti.CREATE_DATE | dateTimeAgo: second }}
              </small>
            </div>
            <small class="text-muted cut-text" [innerHTML]="noti.NOTI_DETAIL"></small>
          </div>
        </a>
        <a *ngIf="getLength(notiArr) > 0" href="/notification"
          class="list-group-item list-group-item-action flex-column align-items-start p-1">
          <div class="d-flex w-100 justify-content-center">
            <h6 class="mb-1 viewAll">ดูทั้งหมด</h6>
          </div>
        </a>

        <div *ngIf="getLength(notiArr) === 0" class="p-3 text-center text-muted">
          ยังไม่มีการแจ้งเตือน
        </div>
      </div>
    </div>
  </li>

  <ul class="d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="!token && !profile"></ul>

  <!-- Desktop -->
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item">

        <form [formGroup]="searchForm">
          <div class="input-group border" style="border-radius: 30px;" *ngIf="searchPath !== 'search'">
            <input class="form-control mr-sm-2" [(ngModel)]="inputValue" formControlName="input" type="search"
              placeholder="ค้นหา" aria-label="Search" nz-input [nzAutocomplete]="auto"
              (ngModelChange)="onChange($event)" (focus)="getSuggestSearch()"
              style="border: none; border-top-left-radius: 30px; border-bottom-left-radius: 30px;">
            <nz-autocomplete [nzDataSource]="filteredOptions" #auto></nz-autocomplete>
            <div class="input-group-append">
              <button class="btn" type="submit" [disabled]="!searchForm.valid" (click)="searchClick()">
                <img src="assets/other/search (black).png" alt="" width="15px">
              </button>
            </div>
          </div>
        </form>

      </li>
      <li class="nav-item" [class.active]="path === 'e-learning'">
        <a class="nav-link" href="e-learning">คอร์สเรียน <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item" [class.active]="path === 'activity'">
        <a class="nav-link" href="activity">กิจกรรม</a>
      </li>
      <li class="nav-item" [class.active]="path === 'measure'">
        <a class="nav-link" href="measure">แบบทดสอบ</a>
      </li>
      <li class="nav-item" [class.active]="path === 'research'">
        <a class="nav-link" href="research">ระบบวิจัย</a>
      </li>
      <li class="nav-item" [class.active]="path === 'learning-center'">
        <a class="nav-link" href="learning-center">ศูนย์เรียนรู้</a>
      </li>
      <li class="nav-item" [class.active]="path === 'about'">
        <a class="nav-link" href="about">เกี่ยวกับเรา</a>
      </li>
      <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="token && profile"
        [class.active]="path === 'profile'">
        <a class="nav-link" href="profile">ข้อมูลของฉัน</a>
      </li>
      <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="token && profile"
        [class.active]="path === 'user-history'">
        <a class="nav-link" href="user-history">ประวัติทั้งหมดของฉัน</a>
      </li>
      <!-- <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="token && profile"
        [class.active]="path === 'setting'">
        <a class="nav-link" href="#">ตั้งค่า</a>
      </li> -->
      <div class="dropdown-divider"></div>
      <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf="!token">
        <a class="nav-link" href="/login" *ngIf="!token">Login</a>
      </li>
      <li class="nav-item dropdown d-sm-block d-sm-block d-md-block d-lg-none d-xl-none" *ngIf=" token">
        <a class="nav-link" (click)="logout()">Logout</a>
      </li>
    </ul>

    <li class="nav-item dropdown d-none d-sm-none d-md-none d-lg-block d-xl-block" *ngIf="token && profile">
      <a class="nav-link mt-1" id="notiDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false" (click)="viewNoti()">
        <img src="assets/notification.png" width="23" height="23" alt="">
        <span *ngIf="notibadge > 0" [matBadge]="notibadge >= 99 ? '99+' : notibadge" matBadgeOverlap="true"
          matBadgeColor="warn" style="display: inline-block;"></span>
      </a>

      <div class="dropdown-menu dropdown-menu-right noti-width-desktop" aria-labelledby="notiDropdown">
        <div class="list-group">
          <a *ngFor="let noti of notiArr; let i = index;"
            class="list-group-item list-group-item-action flex-column align-items-start"
            [ngClass]="i < 7 ? '' : 'd-none'" (click)="updateStatusNoti(noti)">
            <div *ngIf="i < 7">
              <div class="d-flex w-100 justify-content-between">
                <h6 [ngClass]="noti.NOTI_STATUS === 0 ? 'unread' : null" class="mb-1">{{ noti.NOTI_TITLE }}</h6>
                <small class="text-muted">
                  <span *ngIf="noti.NOTI_STATUS === 0" class="unread">
                    •</span> {{ noti.CREATE_DATE | dateTimeAgo: second }}
                </small>
              </div>
              <small class="text-muted cut-text" [innerHTML]="noti.NOTI_DETAIL"></small>
            </div>
          </a>
          <a *ngIf="getLength(notiArr) > 0" href="/notification"
            class="list-group-item list-group-item-action flex-column align-items-start p-1">
            <div class="d-flex w-100 justify-content-center">
              <h6 class="mb-1 viewAll">ดูทั้งหมด</h6>
            </div>
          </a>

          <div *ngIf="getLength(notiArr) === 0" class="p-3 text-center text-muted">
            ยังไม่มีการแจ้งเตือน
          </div>
        </div>
      </div>
    </li>

    <li class="nav-item dropdown d-none d-sm-none d-md-none d-lg-block d-xl-block" *ngIf="token && profile">
      <a class="nav-link" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <img [src]="profile.result.PROFILE_PIC" width="30" height="30" alt="">
      </a>
      <div class="dropdown-menu dropdown-menu-right login-desktop" aria-labelledby="navbarDropdown">
        <a href="profile" class="list-group-item list-group-item-action flex-column align-items-start text-muted">
          ข้อมูลของฉัน
        </a>
        <a href="user-history" class="list-group-item list-group-item-action flex-column align-items-start text-muted">
          ประวัติทั้งหมดของฉัน
        </a>
        <a (click)="logout()" class="list-group-item list-group-item-action flex-column align-items-start text-muted">
          Logout
        </a>
      </div>
    </li>
    <a class="nav-link d-none d-sm-none d-md-none d-lg-block d-xl-block" href="/login" *ngIf="!token">Login</a>
  </div>
</nav>
